import React from "react";
import { Alert } from "@material-ui/lab";
import { decimalFixed } from "../../../../utils/consts";
import { formatDecimalNumber } from "../../../../utils/format";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import DiffAmountNotification from "../../../elements/balances/BalanceDiffAmountNotification";
import { useTranslation } from "react-i18next";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../styles/styledTable";

const CashFlowBalancesList = ({ balances, setBalances }) => {
  const { t } = useTranslation("cashFlow");

  if (!balances) {
    return <PageSpinner position="center" pt="20" pb="20" />;
  }

  if (balances.length === 0) {
    return <Alert severity="warning">{t("balances.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="576"
        size="16"
        className="user-balances-table"
      >
        <StyledTableHead
          scroll="auto"
          col="3"
          className="user-balances-table__head"
        >
          <div>
            {t("balances.table.service")}
          </div>
          <div>
            {t("balances.table.balance")}
          </div>
          <div>
            {t("balances.table.currency")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {balances && balances.map((value, key) => (
            <StyledTableRow
              key={key}
              scroll="auto"
              col="3"
              className="user-balances-table__row"
            >
              <StyledCol>
                {getServiceNameWithNickname(value.service_name, value.service_nickname)}
              </StyledCol>
              <StyledCol className="user-balances-table__amount">
                <div className="amount">
                  {formatDecimalNumber(value.totalAmount, decimalFixed)}
                  <DiffAmountNotification balances={balances} setBalances={setBalances} diff={value.diff} />
                </div>
              </StyledCol>
              <StyledCol>
                {value.currency_asset}
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default CashFlowBalancesList;